import GerenciarUsuariosLista from "../GerenciarUsuariosLista";

interface GerenciarUsuariosProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
}

const GerenciarUsuarios: React.FC<GerenciarUsuariosProps> = ({
  token,
  role,
}) => {
  return <GerenciarUsuariosLista token={token} role={role} />;
};

export default GerenciarUsuarios;
